import { Box } from '@factorialco/deprecated-design-system'

const Separator = () => {
  return <Box width="s1" height="s20" className="bg-f1-background-secondary" />
}

export { Separator }
